import { render, staticRenderFns } from "./context-topic.vue?vue&type=template&id=10ca734b"
import script from "./context-topic.vue?vue&type=script&lang=js"
export * from "./context-topic.vue?vue&type=script&lang=js"
import style0 from "./context-topic.vue?vue&type=style&index=0&id=10ca734b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports